import { FetchErrorWithData } from 'century-core/core-apis/fetch';
import { GET, PUT } from 'century-core/core-apis/utils';
import { getAssignmentUrl } from './assignmentV1';
import { CommonCourses, SmartRecommendationSettings } from './types';

export function addEditRecommendedNuggets(
  token: string,
  assignmentId: string,
  body: Partial<SmartRecommendationSettings>,
  signal?: AbortSignal
) {
  const url = getAssignmentUrl(`/assignments/${assignmentId}/recommendations`);
  return PUT({ url, token, body, signal });
}

export function getCommonCourses(token: string, assignmentId: string, signal?: AbortSignal) {
  const url = getAssignmentUrl(`/assignments/${assignmentId}/recommendations/common-courses`);
  return GET<CommonCourses>({ url, token, signal }).catch((error: FetchErrorWithData) => {
    throw new Error(`Failed to get common courses: ${error.message}`);
  });
}
